import React from 'react';
import { connect } from 'react-redux';
import { selectShipment } from '../../actions/tracking';
import PropTypes from 'prop-types';
import ShipmentTabs from './ShipmentTabs/ShipmentTabs';
import OrderStatus from './OrderStatus';
import Carrier from './Carrier';
import CarrierMessages from './CarrierMessages/CarrierMessages';
import StatusTimeline from './StatusTimeline';
import ShipmentStatus from './ShipmentStatus';
import ETA from './ETA';
import DynamicContentBadge from '../DynamicContentBadge';

import './Status.module.scss';
import { getSelectedShipment } from '../../reducers/tracking';

export class Status extends React.PureComponent {
  componentDidMount() {
    const {
      trackingData: { shipments = [] },
      onSelectShipment,
    } = this.props;

    const trackingPageUrlFragment = window.location.hash.substring(1);

    if (trackingPageUrlFragment) {
      const selectedShipmentTabIndex = this.getShipmentIndexByTrackingCode(trackingPageUrlFragment, shipments); // -> 1
      onSelectShipment(selectedShipmentTabIndex);
    }
  }

  getShipmentIndexByTrackingCode = (trackingCode, sortedShipments) => {
    const shipmentIndex = sortedShipments.findIndex((shipment) => shipment.carrier.trackingCode === trackingCode);
    const shipmentIndexByTrackingCodeFound = shipmentIndex !== -1;

    if (shipmentIndexByTrackingCodeFound) {
      return shipmentIndex;
    }

    return 0;
  };

  renderCarrierMessages(carrierMessages, isMobile, locale) {
    const {
      carrierMessagesHideOnEntry,
      carrierMessagesFullDate,
      carrierMessagesCount,
      designSettings,
      showHistoryLabel,
      hideHistoryLabel,
    } = this.props;

    if (carrierMessages.length) {
      return (
        <CarrierMessages
          isMobile={isMobile}
          data={carrierMessages}
          count={carrierMessagesCount}
          fullDate={carrierMessagesFullDate}
          defaultCollapsed={carrierMessagesHideOnEntry}
          designSettings={designSettings}
          locale={locale}
          showHistoryLabel={showHistoryLabel}
          hideHistoryLabel={hideHistoryLabel}
        />
      );
    }
  }

  render() {
    const {
      isMobile,
      isPreview,
      showStatus,
      showOrderStatusIcon,
      showCarrierMessages,
      showCarrier,
      showCarrierLogo,
      showCarrierLink,
      showCarrierTrackingCode,
      showShipmentStatusIcon,
      showETA,
      etaIncludeDayOfWeek,
      etaDisableIfNoShipments,
      trackingData: { locale = 'en-US', shipments = [], order = {} },
      selectedShipmentIndex,
      selectedShipment,
      onSelectShipment,
      disabledOnceShipmentsCreated,
      showTimeline,
      timelineShowDate,
      timelineShowIcon,
      timelineMobileOrder,
      hideFutureStates,
      designSettings,
      designSettings: { bodyBackgroundColor, carrierBackgroundColor },
      shipmentTabLabel,
      returnTabLabel,
      carrierLinkLabel,
      carrierTrackingCodeLabel,
      etaLabel,
    } = this.props;

    const showOrderStatus = showStatus && !(disabledOnceShipmentsCreated && shipments.length);
    const etaEnabled = showETA && !(etaDisableIfNoShipments && !shipments.length);
    const showShipmentStatus = showStatus && !!shipments.length;
    const { carrier, statusTimeline, estimatedTimeOfArrival, carrierMessages = [] } = selectedShipment;
    const estimatedArrival = shipments.length ? estimatedTimeOfArrival : order.promisedDeliveryDate;

    return (
      <div styleName="status" style={{ bodyBackgroundColor }}>
        {showOrderStatus && (
          <OrderStatus
            {...order.lastEvent}
            showIcon={showOrderStatusIcon}
            isMobile={isMobile}
            designSettings={designSettings}
            locale={locale}
          />
        )}
        {shipments.length > 1 && (
          <ShipmentTabs
            shipments={shipments}
            selected={selectedShipmentIndex}
            onSelect={onSelectShipment}
            isMobile={isMobile}
            designSettings={designSettings}
            shipmentTabLabel={shipmentTabLabel}
            returnTabLabel={returnTabLabel}
          />
        )}
        {etaEnabled && estimatedArrival && (
          <ETA
            estimatedArrival={estimatedArrival}
            includeDayOfWeek={etaIncludeDayOfWeek}
            isMobile={isMobile}
            designSettings={designSettings}
            locale={locale}
            etaLabel={etaLabel}
          />
        )}
        {showShipmentStatus && (
          <ShipmentStatus
            {...selectedShipment.lastEvent}
            showIcon={showShipmentStatusIcon}
            isMobile={isMobile}
            designSettings={designSettings}
            locale={locale}
          />
        )}
        {showTimeline && (
          <StatusTimeline
            isMobile={isMobile}
            data={statusTimeline}
            mobileOrder={timelineMobileOrder}
            showDate={timelineShowDate}
            showIcon={timelineShowIcon}
            hideFutureStates={hideFutureStates}
            designSettings={designSettings}
            locale={locale}
          />
        )}
        {showCarrierMessages && this.renderCarrierMessages(carrierMessages, isMobile, locale)}
        {showShipmentStatus && showCarrier && (
          <Carrier
            {...carrier}
            isMobile={isMobile}
            showLogo={showCarrierLogo}
            showLink={showCarrierLink}
            showTrackingCode={showCarrierTrackingCode}
            designSettings={designSettings}
            carrierLinkLabel={carrierLinkLabel}
            carrierTrackingCodeLabel={carrierTrackingCodeLabel}
          />
        )}
        {isPreview && <DynamicContentBadge />}
      </div>
    );
  }
}

Status.defaultProps = {
  selectedShipment: {},
  designSettings: {},
};

Status.propTypes = {
  showStatus: PropTypes.bool,
  showOrderStatusIcon: PropTypes.bool,

  showCarrierMessages: PropTypes.bool,
  carrierMessagesHideOnEntry: PropTypes.bool,
  carrierMessagesFullDate: PropTypes.bool,
  carrierMessagesCount: PropTypes.number,

  isPreview: PropTypes.bool,
  isMobile: PropTypes.bool,
  trackingData: PropTypes.shape({
    order: PropTypes.object,
    shipments: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
  selectedShipmentIndex: PropTypes.number,
  onSelectShipment: PropTypes.func,
  designSettings: PropTypes.shape({
    bodyBackgroundColor: PropTypes.string,
    carrierBackgroundColor: PropTypes.string,
  }),
};

function mapStateToProps(state) {
  const {
    tracking: { data: trackingData, selectedShipmentIndex },
  } = state;

  return {
    trackingData,
    selectedShipmentIndex,
    selectedShipment: getSelectedShipment(state),
  };
}

function mapDispatchToProps(dispatch, props) {
  return {
    onSelectShipment: (id) => dispatch(selectShipment(id)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Status);
